/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrustedCompanyContent } from '../../models/trusted-company-content';

export interface ApiMasterTrustedCompanyContentGetAllGet$Params {
}

export function apiMasterTrustedCompanyContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrustedCompanyContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrustedCompanyContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrustedCompanyContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrustedCompanyContent>>;
    })
  );
}

apiMasterTrustedCompanyContentGetAllGet.PATH = '/api/Master/TrustedCompanyContent/GetAll';
